<template>
  <v-btn
    :color="color"
    :depressed="depressed"
    :min-width="minWidth"
    :tile="tile"
    class="font-weight-bold"
    x-large
    v-bind="$attrs"
  >
    <slot />
  </v-btn>
</template>

<script setup>
defineOptions({
  name: 'BaseBtn',
})

const props = defineProps({
  color: {
    type: String,
    default: 'primary',
  },
  depressed: {
    type: Boolean,
    default: true,
  },
  minWidth: {
    type: [Number, String],
    default: 164,
  },
  tile: {
    type: Boolean,
    default: true,
  },
})
</script>
